import { render, staticRenderFns } from "./StatementsUpdate.vue?vue&type=template&id=2cf15d7d&scoped=true"
import script from "./StatementsUpdate.vue?vue&type=script&lang=js"
export * from "./StatementsUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf15d7d",
  null
  
)

export default component.exports